import { createContext, useState } from "react";

const NavbarItemsContext = createContext({
  selectedIndex: -1,
  setSelectedIndex: null,
});

export const NavbarItemsProvider = ({ children }) => {
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const value = {
    selectedIndex,
    setSelectedIndex,
  };

  return (
    <NavbarItemsContext.Provider value={value}>
      {children}
    </NavbarItemsContext.Provider>
  );
};

export default NavbarItemsContext;
